import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { BodyText, OtherText } from 'styling/Typography'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { NoData } from 'components/NoData'
import { IMaterialAuditEntry } from 'types/materialReceipt.interface'
import { MaterialReceiptPage } from './MaterialReceiptShell'

export const MaterialAudit = () => {
  const navigate = useNavigate()
  const { auditLog } = useSelector((s: RootState) => s.materialReceipt)

  const columns: IHonestTableColumn<IMaterialAuditEntry>[] = [
    { id: 'at', header: 'Time', cell: (e) => e.at },
    { id: 'ticket', header: 'Ticket', cell: (e) => <BodyText weight='600' style={{ margin: 0 }}>{e.ticket}</BodyText> },
    { id: 'action', header: 'Action', cell: (e) => e.action },
    { id: 'actor', header: 'Actor', cell: (e) => e.actor },
    {
      id: 'change',
      header: 'Change',
      cell: (e) => (e.from || e.to ? `${e.from || '—'} → ${e.to || '—'}` : '—'),
    },
    {
      id: 'reason',
      header: 'Reason',
      cell: (e) => (e.reason ? <OtherText grey>{e.reason}</OtherText> : '—'),
    },
  ]

  return (
    <MaterialReceiptPage requireManager title='Audit trail' subtitle='Append-only — every finalize, reopen and case decision'>
      {() => (
        <>
          {auditLog.length ? (
            <HonestTable
              columns={columns}
              data={auditLog}
              keyField='id'
              onClick={(e) => navigate(`/material-receipt/ticket/${e.ticket}`)}
            />
          ) : (
            <NoData text='No audit entries yet.' />
          )}
        </>
      )}
    </MaterialReceiptPage>
  )
}
